import type { Customer } from "@lib/api-services/services/profile-service/types";
import { isEqual } from "lodash-es";

export const applyBaseCustomerFields = (target: Customer, source: Customer) => {
    // eslint-disable-next-line no-param-reassign
    target.firstName = source.firstName;
    // eslint-disable-next-line no-param-reassign
    target.lastName = source.lastName;
    // eslint-disable-next-line no-param-reassign
    target.email = source.email;
    // eslint-disable-next-line no-param-reassign
    target.phoneNumber = source.phoneNumber || "";
    // eslint-disable-next-line no-param-reassign
    target.gender = source.gender || "";
    // eslint-disable-next-line no-param-reassign
    target.dateOfBirth = source.dateOfBirth;
};

export const applyAdditionalFields = (target: Customer, source: Customer) => {
    // eslint-disable-next-line no-param-reassign
    target.phoneticFirstName = source.phoneticFirstName || "";
    // eslint-disable-next-line no-param-reassign
    target.phoneticLastName = source.phoneticLastName || "";
    // eslint-disable-next-line no-param-reassign
    (target as any).countryCode = source.phoneCountryCode || "";
    // eslint-disable-next-line no-param-reassign
    target.loyalty = source.loyalty ?? null;

    if (!isEqual(target.activeConsentTypes, source.activeConsentTypes)) {
        // eslint-disable-next-line no-param-reassign
        target.activeConsentTypes = source.activeConsentTypes;
    }
};
